// extracted by mini-css-extract-plugin
module.exports = {"header":"OrdersDetail_header__2OP5O index_flex-row__3TsjP","backButton":"OrdersDetail_backButton__2weH_"};